import { HttpResponse } from '@angular/common/http';
import { PaymentMethodClass } from '@shared/factories/payment-method.factory';
import { SetupIntent } from '@shared/models/interfaces/setup-intent.interface';
import { Observable } from 'rxjs';
import { Expense } from './expenses.interface';
import { Filters, FiltersDto } from './filters.interface';
import { DeletePaymentMethodResponse, Payments, PaymentsResponse } from './payments.interface';

export abstract class PaymentRepository {
    abstract getSetupIntent(): Observable<SetupIntent>;
    abstract getTotalExpensesByMonth(): Observable<Expense[]>;
    abstract getPaymentList(page: number, pageSize: number, filtersDto: FiltersDto): Observable<PaymentsResponse>;
    abstract getDetail(paymentId: string): Observable<Payments>;
    abstract setDefaultPaymentMethod(paymentId: string): Observable<unknown>;
    abstract getFilters(filtersDto: FiltersDto): Observable<Filters>;
    abstract getPaymentMethodList(): Observable<PaymentMethodClass[]>;
    abstract deletePaymentMethod(id: string): Observable<DeletePaymentMethodResponse>;
    abstract exportPayments(filtersDto: FiltersDto, format?: string): Observable<HttpResponse<Blob>>;
    abstract downloadInvoicePdf(paymentId: string): Observable<HttpResponse<Blob>>;
    abstract exportPaymentById(paymentId: string): Observable<HttpResponse<Blob>>;
}
